module.exports = __webpack_public_path__ + "static/screen-web-tasks-a5484c621091b5df569e72b11bbd6371.png";